const audience = [
  "Leadership teams navigating change",
  "Organizations addressing burnout and engagement",
  "Conferences focused on performance and wellbeing",
  "Women navigating reinvention or transition",
  "Schools and communities rebuilding after disruption",
];

const formats = [
  "Keynotes (45–60 minutes)",
  "Half-Day Workshops",
  "Full-Day Intensives",
  "Retreat Facilitation",
];

export function AudienceFormats() {
  return (
    <section
      data-testid="audience-formats-section"
      className="relative overflow-hidden"
      style={{ background: "linear-gradient(180deg, #F8F7F5 0%, #FAFAF8 100%)" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-8 md:pt-10 pb-14 md:pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-0">

          <div className="lg:col-span-7 lg:pr-16 reveal">
            <p className="text-[11px] tracking-[0.28em] uppercase text-[#F6A041] mb-7 font-medium">
              Who It's For
            </p>
            <ul className="space-y-6">
              {audience.map((item, i) => (
                <li key={i} className="flex items-start gap-5 text-[#2E2E2E] text-xl leading-snug">
                  <span className="mt-[9px] w-2 h-2 rounded-full bg-[#159E9A] flex-shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="hidden lg:flex lg:col-span-1 items-stretch justify-center">
            <div className="w-px bg-[#E8E6E3]" />
          </div>

          <div className="lg:col-span-4 lg:pl-12 reveal">
            <p className="text-[11px] tracking-[0.28em] uppercase text-[#F6A041] mb-7 font-medium">
              Speaking Formats
            </p>
            <ul className="space-y-6">
              {formats.map((item, i) => (
                <li key={i} className="flex items-start gap-5 text-[#2E2E2E] text-xl leading-snug">
                  <span className="mt-[9px] w-2 h-2 rounded-full bg-[#FF5A4F] flex-shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>

        </div>
      </div>
    </section>
  );
}
